module.exports = __webpack_public_path__ + "static/media/avion_hidrogeno.f0644202.PNG";